<template>
  <div class="pt-2">
    <v-card flat>
      <v-form v-model="valid">
        <v-row no-gutters align="center" justify="space-around">
          <!--<v-col cols="12" sm="1" style="text-align: right">
            <label>检查单号：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.checkId"
              dense
              outlined
            ></v-text-field>
          </v-col>-->
          <v-col cols="12" sm="1" style="text-align: right">
            <label>检查门店：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <pd-shop-multiple-list
              v-model="filter.shopIds"
              isSearch
            ></pd-shop-multiple-list>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>标题：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.title"
              single-line
              outlined
              dense
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="1" style="text-align: right">
            <label>检查起止日期：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <date-range label="" v-model="filter.dateRange"></date-range>
          </v-col> -->
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" depressed @click="handleSearch"
              >查询</v-btn
            >
            <v-btn depressed @click="handleResetSearch">重置</v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters align="center">
          
          <!--<v-col cols="12" sm="1" style="text-align: right">
            <label>合同状态：</label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              v-model="filter.status"
              :items="statusList"
              item-text="name"
              item-value="id"
              outlined
              dense
            ></v-select>
          </v-col>-->
          
        </v-row>
        <!-- <v-row no-gutters align="center">
          <v-col cols="12" sm="3">
            <shop-list
              v-model="filter.storeId"
              type="2"
            ></shop-list>
          </v-col>
        </v-row> -->
      </v-form>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :loading="loading"
        :server-items-length="totalDesserts"
        :page.sync="filter.pageNum"
        :items-per-page.sync="filter.pageSize"
        @update:page="handlePageChanged"
        @update:items-per-page="handlePageSizeChanged"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" :disabled="!_hasButtonPermission('导出列表')" depressed class="mr-2" @click="handleExport">
              导出
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.status="{ item }">
          {{_jungleStatus(item.status)}}
        </template>
        <template v-slot:item.allWriteOff="{ item }">
          {{item.preWriteOff + item.alreadyWriteOff}}
        </template>
        <template v-slot:item.commonWriteOff="{ item }">
          {{item.alreadyWriteOff - item.overtimeWriteOff}}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn text color="primary" :disabled="!_hasButtonPermission('查看详情')" small @click="viewDetail(item)"
            >查看</v-btn
          >
          <v-btn text color="primary"
            @click="clickAudit(item.id)"
            small
            :disabled="!(item.status==2&&_hasButtonPermission('审批'))"
          >
            审批
          </v-btn>
        </template>
        <template v-slot:no-data> 查询出错或没有数据 </template></v-data-table
      >
      <!--审批弹窗-->
      <v-dialog
        v-model="auditDialog"
        width="300"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            请审批
          </v-card-title>
          <v-card-text>
            <div class="padding-bottom padding-top">
              <v-btn
                depressed
                color="primary"
                class="margin-right"
                :disabled="btnDisabled"
                @click="auditApprove()"
              >
                审批通过
              </v-btn>
              <v-btn
                depressed
                color="primary"
                :disabled="btnDisabled"
                @click="auditDismissal()"
              >
                驳回
              </v-btn>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="hideAudit"
            >
              取消
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import {default as CheckRecordApi} from "@/api/pd/check/checkRecord/CheckRecordApi.js";
import downloadUtil from "@/util/downloadUtil.js";
export default {
  props: {
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      tab: null,
      statusList: [
        { id: 1, name: "待提交" },
        { id: 2, name: "待审批" },
        { id: 3, name: "执行中" },
        { id: 4, name: "已过期" },
        { id: 5, name: "已终止" },
      ],
      filter: {
        checkId: "",
        title: "",
        shopIds: [],
        dateRange: [],
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        { text: "检查单号", value: "id", width: 100, sortable: false },
        { text: "检查门店", value: "shopName", width: 120, sortable: false },
        { text: "检查标题", value: "title", width: 120, sortable: false },
        { text: "综合得分", value: "totalScore", width: 100, sortable: false },
        { text: "总需销项数", value: "allWriteOff", width: 80, sortable: false },
        { text: "待销项", value: "preWriteOff", width: 80, sortable: false },
        { text: "超期待销项", value: "overtimePreWriteOff", width: 80, sortable: false },
        { text: "按期销项", value: "commonWriteOff", width: 80, sortable: false },
        { text: "超期销项", value: "overtimeWriteOff", width: 80, sortable: false },
        { text: "状态", value: "status", width: 80, sortable: false },
        { text: "检查人", value: "createBy", width: 100, sortable: false },
        { text: "提交时间", value: "createTime", width: 130, sortable: false },
        { text: "审批人", value: "auditBy", width: 100, sortable: false },
        { text: "审批时间", value: "auditTime", width: 130, sortable: false },
        { text: "操作", value: "actions", sortable: false, width: 120 },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      valid: false,
      auditDialog: false,
      checkId: null,
      btnDisabled: false
    };
  },
  mounted(){
	  // this.getDataFromApi();
  },
  methods: {
    // 点击审批
    clickAudit(checkId){
      this.auditDialog = true
      this.checkId = checkId
    },
    hideAudit(){
      this.auditDialog = false
      this.checkId = null
    },
    // 审批通过
    auditApprove(){
      let checkId = this.checkId
      let me = this
      me.btnDisabled = true
      CheckRecordApi.approveCheckOrder({
        checkId: checkId
      }).then(resp=>{
        CheckRecordApi.handleResponse(resp, me, function (data){
          me.$dialog.info({
            text:'审批通过',
            title:'操作成功'
          })
          me.hideAudit()
          me.btnDisabled = false
          me.getDataFromApi()
        },()=>{
          me.btnDisabled = false
        })
      }).catch(error=>{
        CheckRecordApi.handleNetworkError(error, me, function (){
          me.btnDisabled = false
        })
      })
    },
    // 审批驳回
    auditDismissal(){
      let checkId = this.checkId
      let me = this
      me.btnDisabled = true
      CheckRecordApi.dismissalCheckOrder({
        checkId: checkId
      }).then(resp=>{
        CheckRecordApi.handleResponse(resp, me, function (data){
          me.$dialog.info({
            text:'审批驳回成功',
            title:'操作成功'
          })
          me.hideAudit()
          me.btnDisabled = false
          me.getDataFromApi()
        },()=>{
          me.btnDisabled = false
        })
      }).catch(error=>{
        CheckRecordApi.handleNetworkError(error, me, function (){
          me.btnDisabled = false
        })
      })
    },
    async handleExport(){
      // 校验门店必选
      if(!this.filter.shopIds||this.filter.shopIds.length==0){
        this.$dialog.error({
          title:'错误',
          text:'请选择门店'
        })
        return
      }
      let me = this;
      let filter = this.getQueryParams(this.filter)
      let res = await CheckRecordApi.exportData({
        shopIds: me.filter.shopIds.join(','),
        title: me.filter.title,
        beginTime: me.filter.beginTime,
        endTime: me.filter.endTime,
        pageNum: me.filter.pageNum,
        pageSize: me.filter.pageSize
      });
      downloadUtil.downloadByBlob({ res: res.data, fileName: "检查记录列表导出数据.xlsx" });
    },
    viewDetail(item){
      this.$emit("viewDetailCallback", {formStatus:'detail',checkId:item.id})
    },
    handleSearch(){
      // 校验门店必选
      if(!this.filter.shopIds||this.filter.shopIds.length==0){
        this.$dialog.error({
          title:'错误',
          text:'请选择门店'
        })
        return
      }
		  this.getDataFromApi();	 
	  },
    handleResetSearch(){
      this.filter = {
        checkId: "",
        title: "",
        shopIds: [],
        dateRange: [],
        pageNum: 1,
        pageSize: 15,
      }
      this.getDataFromApi();
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum
      this.getDataFromApi()
    },
    handlePageSizeChanged(pageSize) {
      if(pageSize==-1){
        pageSize = 100
      }
      this.filter.pageNum = 1
      this.filter.pageSize = pageSize
      this.getDataFromApi()
    },
    getQueryParams(query) {
      let dateRange = query.dateRange
      if (dateRange && dateRange.length) {
        query.beginTime = dateRange[0]
        query.endTime = dateRange[1]
      }
      return query
    },
    getDataFromApi () {
      this.loading = true;
      this.desserts = [];
      let me = this;
      CheckRecordApi.listCheckOrder(this.getQueryParams(this.filter)).then(resp=>{
        CheckRecordApi.handleResponse(resp, me, function (data){
          me.loading = false;
          me.desserts = data.rows;
          me.totalDesserts = data.total;
        }, function (){
          me.loading = false;
        })
      }).catch(error=>{
        CheckRecordApi.handleNetworkError(error, me, function (){
          me.loading = false;
        })
      })
    },
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
    _jungleStatus(status){
      if(status==1){
        return "待提交"
      } else if(status==2){
        return "待审批"
      } else if(status==3){
        return "待销项"
      } else {
        return "已完成"
      }
    }
  },
};
</script>
<style scoped>
.padding-bottom{
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}
.padding-top{
  padding-top: 30px;
}
.margin-right{
  margin-right: 12px;
}
</style>